import React, { useEffect } from 'react';
import { NavLink as RouteNavLink } from 'react-router-dom';
import { NavItem, NavLink } from 'shards-react';
import TooltipWithArrow from '../../common/TooltipWithArrow';
import { RootState, useDispatch, useSelector } from '../../../redux/store';
import { getNewss } from '../../../redux/slices/news';
import moment from 'moment';
import type { Moment } from 'moment';
import type { SidebarNav } from '../../../types/common';
import type { NewsType } from '../../../types/news';

interface SidebarNavItemProps {
  item: SidebarNav;
}

const SidebarNavItem = ({ item }: SidebarNavItemProps): React.ReactElement => {
  const dispatch = useDispatch();
  const { sidebarOpen } = useSelector((state: RootState) => state.session);
  const newss = item.id === 'sidebarNavNews' ? useSelector((state: RootState) => state.news.newss) : undefined;

  // ドラフトでなく、かつ期限内のニュースがあるか確認する
  const activeNews: NewsType[] =
    item.id === 'sidebarNavNews' && newss
      ? newss.filter((news) => {
          const isDraft: boolean = news.isDraft;
          const now: Moment = moment(new Date());
          const startDate: Moment | undefined = moment(news.publicationStartAt).isValid() ? moment(news.publicationStartAt) : undefined;
          const endDate: Moment | undefined = moment(news.publicationEndAt).isValid() ? moment(news.publicationEndAt) : undefined;
          // console.log(now, startDate, endDate);
          // startDateやendDateがinvalidな場合は（通知しないよりしたほうがよいので）判定を通す
          const isActive: boolean = startDate && endDate ? moment(now).isBetween(startDate, endDate) : true;
          return !isDraft && isActive;
        })
      : [];
  const hasActiveNews: boolean = activeNews.length > 0;
  const alarmClass: string = hasActiveNews ? 'alarm' : '';

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  useEffect(() => {
    if (item.id === 'sidebarNavNews') {
      dispatch(getNewss());
    }
  }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      <TooltipWithArrow id={item.id + 'Tip'} title={item.title} disabled={sidebarOpen}>
        <div id={item.id}>
          <NavItem>
            {/* https://stackoverflow.com/questions/62410179/warning-failed-prop-type-invalid-prop-tag-supplied-to-navlink */}
            <NavLink tag={(props) => <RouteNavLink {...props} />} to={item.to}>
              {item.htmlBefore && <div className={'d-inline-block item-icon-wrapper ' + alarmClass} dangerouslySetInnerHTML={{ __html: item.htmlBefore }} />}
              {item.title && <span>{item.title}</span>}
              {item.htmlAfter && <div className="d-inline-block item-icon-wrapper" dangerouslySetInnerHTML={{ __html: item.htmlAfter }} />}
            </NavLink>
          </NavItem>
        </div>
      </TooltipWithArrow>
    </>
  );
};

export default SidebarNavItem;
